// Shows 2 decimals only when the price has a fraction: 1148 -> "1148", 475.2 -> "475.20"
export const formatPrice = (value: number | string): string =>
  Number(value).toFixed(2).replace(/\.00$/, '');
